export const label = {
  'es-US': 'Siguiente',
  'zh-TW': '下一步',
  ar: 'التالي',
  az: 'Növbəti',
  be: 'Далей',
  bg: 'Напред',
  bs: 'Dalje',
  cnr: 'Dalje',
  cs: 'Další',
  da: 'Næste',
  de: 'Weiter',
  el: 'Επόμενο',
  en: 'Next',
  es: 'Siguiente',
  et: 'Järgmine',
  fi: 'Seuraava',
  fr: 'Suivant',
  he: 'הבא',
  hr: 'Dalje',
  hu: 'Következő',
  hy: 'Հաջորդը',
  id: 'Berikutnya',
  is: 'Næsta',
  it: 'Avanti',
  ja: '次へ',
  ka: 'შემდეგი',
  ko: '다음',
  lt: 'Kitas',
  lv: 'Tālāk',
  mk: 'Следно',
  nl: 'Volgende',
  no: 'Neste',
  pl: 'Dalej',
  pt: 'Seguinte',
  ro: 'Următorul',
  ru: 'Далее',
  sk: 'Ďalej',
  sl: 'Naprej',
  sq: 'Tjetri',
  sr: 'Sledeće',
  sv: 'Nästa',
  th: 'ถัดไป',
  tr: 'Sonraki',
  uk: 'Далі',
  vi: 'Tiếp theo',
  zh: '下一步',
};
